<template>
    <div>
        <el-button v-on:click="backHistory">返回</el-button>
        <el-form
            :model="query"
            class="find-add"
            label-width="110px"
            autocomplete="on"
        >
            <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6">
                    <el-form-item label="名称:">
                        <el-input
                            v-model="query.name"
                            placeholder="请输入内容"
                            style="width: 100%"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8">
                    <el-form-item label="类别:">
                        <el-radio v-model="query.type" label="1">文章</el-radio>
                        <el-radio v-model="query.type" label="2">广告</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8">
                    <el-form-item label="文章id/跳转url:">
                        <el-input
                            v-model="query.url"
                            placeholder="请输入文章id或跳转url"
                            style="width: 100%"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6">
                    <el-form-item label="起始时间:">
                        <el-date-picker
                            v-model="query.start_time"
                            type="datetime"
                            style="width: 100%"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间"
                            :picker-options="expireTimeOption"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6">
                    <el-form-item label="终止时间:">
                        <el-date-picker
                            v-model="query.end_time"
                            type="datetime"
                            style="width: 100%"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间"
                            :picker-options="expireTimeOption"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="8">
                    <el-form-item label="开关:">
                        <el-switch
                            v-model="query.is_use"
                            active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="6">
                    <el-form-item label="标题图片:">
                        <div class="uploadLine"  v-for="(item,index) in imagesList" :key="index">
                                <!-- :on-success="handleAvatarSuccess" -->
                                <!-- upload 标签没动 一个完整的 外面加了遍历 data传参  只能用  :http-request 这个事件 去 接收-->
                            <el-upload
                                class="avatar-uploader upload-add"
                                style="width: 220px; height: 199px"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :before-upload="beforeAvatarUpload"
                                :http-request="uploadRequest"
                                :data="{index:index}"
                            >
                                <el-input
                                    v-model="query.img"
                                    style="display: none"
                                    clearable
                                ></el-input>
                                <img
                                    v-if="item.newSrc"
                                    :src="item.newSrc"
                                    class="avatar"
                                    style="width: 220px; height: 199px"
                                />
                                <i
                                    v-else
                                    class="el-icon-plus avatar-uploader-icon"
                                ></i>
                            </el-upload>
                            <span class="upload_text">{{ item.value }}</span>
                        </div>
                        
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row class="button-row">
                <el-button type="info" round v-on:click="backHistory"
                    >取消</el-button
                >
                <el-button
                    type="success"
                    round
                    style="margin-right: 10px"
                    @click.native="onSubmit('add')"
                    >发布</el-button
                >
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { BASE_URL } from "../../config/app";
import Tinymce from "../../components/Tinymce/index.vue";
import {
    screenCeate,
    screenDetail,
    cateCommonlyList,
    createAdd,
    getUploadImage
} from "../../api/posting/posting";
// import { quillRedefine } from 'vue-quill-editor-upload' //引入图片上传
export default {
    data() {
        return {
            dataSource: [{ value: "财富" }, { value: "编者" }],
            programs: {},
            // uploadUrl: "http://tapi.inchengzi.com/upload",
            // uploadUrl: BASE_URL + "/admin/app/Users/getUploadImage",
            uploadUrl: BASE_URL + "/admin/app/Users/getUploadImageScreen",
            dialogImageUrl: "",
            dialogVisible: false,
            disabled: false,
            editorOption: {}, //富文本编辑器配置文件上传路径
            query: {
                screen_id: '',
                name: '',
                type: '',
                url: '',
                is_use: true,
                start_time: '',
                end_time: '',
                // screen_1: '',
                // screen_2: '',
                // screen_3: '',
                // screen_4: '',
                // screen_5: '',
                // screen_6: '',
                // screen_7: '',
                // screen_8: '',
                // screen_9: '',
                // screen_10: '',
                // screen_11: '',
                // screen_12: '',
            },
            //展示图片路径
            imagesList:[ {
                title:'screen_1',
                value:'640x960',
                newSrc: '',
            },{
                title:'screen_2',
                value:'640x1136',
                newSrc: '',
            },{
                title:'screen_3',
                value:'750x1334',
                newSrc: '',
            },{
                title:'screen_4',
                value:'1242x2208',
                newSrc: '',
            },{
                title:'screen_5',
                value:'828x1792',
                newSrc: '',
            },{
                title:'screen_6',
                value:'1125x2436',
                newSrc: '',
            },{
                title:'screen_7',
                value:'1242x2688',
                newSrc: '',
            },{
                title:'screen_8',
                value:'360x640',
                newSrc: '',
            },{
                title:'screen_9',
                value:'540x960',
                newSrc: '',
            },{
                title:'screen_10',
                value:'720x1280',
                newSrc: '',
            },{
                title:'screen_11',
                value:'1080x1920',
                newSrc: '',
            },{
                title:'screen_12',
                value:'1440x2560',
                newSrc: '',
            }],
            imgList: [],
            imgData: {
                accept: 'image/gif, image/jpeg, image/png, image/jpg',
            },
            list: [],
            options: [],
            value: "",
            videoFlag: false,
            //是否显示进度条
            videoUploadPercent: "",
            //进度条的进度，
            isShowUploadVideo: false,
            //显示上传按钮
            videoForm: {
                showVideoPath: "",
                videoName: "",
            },
            data: [
                {
                    label: "一级 1",
                    children: [
                        {
                            label: "二级 1-1",
                        },
                    ],
                },
            ],
            gaoji: false,
            cateList: [],
            dynamicTags: [],
            inputVisible: false,
            inputValue: "",
            cate_name: "",
            FinalTags: [], // 最终版tag选择
            upd_type: "",
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() <= Date.now() - 8.64e7;
                },
            },
        };
    },
    mounted() {
        // console.log(this.restaurants, "restaurants");
    },
    methods: {
        showInput() {
            this.inputVisible = true;

            this.$nextTick((_) => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        // 旧 图片
        // handleAvatarSuccess(res, file) {
        //     this.query.title_photo = res.data;
        //     this.imageUrl = res.data;
        //     this.index = res.data.index
        // },
        // http 上传
        uploadRequest(val) {
            var file = new FormData()
            file.append('file',val.file)
            // console.log(this.imagesList,'this.imagesList');
            getUploadImage(file)
                .then((response) => {
                    // console.log(response,'response');
                    // return ;
                    // 这个 下标  下面的  newSrc 用来存储 图片路劲
                    this.imagesList[val.data.index].newSrc = response.data
                    this.$message({
                        message: "上传成功！",
                        type: "success",
                    });
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        beforeAvatarUpload(file) {
            let file_type = file.type.substr(0, file.type.indexOf("/"));
            if (!["image"].includes(file_type)) {
                this.$message.error("只能上传图片");
                return false;
            }
            if (file_type == "image") {
                // const isLt2M = file.size / 1024 / 1024 < 2;
                const isSize = new Promise(function (resolve, reject) {
                    // let width = 198;
                    // let height = 198;
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function () {
                        // let valid = img.width == width && img.height == height;
                        let valid = true;
                        valid ? resolve() : reject();
                    };
                    img.src = _URL.createObjectURL(file);
                })
                    .then((res) => {
                        return file;
                    })
                    .catch((err) => {
                        this.$message.error(
                            "图片格式错误，请上传长198像素、宽198像素的图片"
                        );
                        return Promise.reject();
                    });
                return isSize;
            }
            this.uploading = true;
        },
        backHistory() {
            this.$router.go(-1); //返回上一层
        },
        // getData() {
        //     openScreen(this.query)
        //         .then(response => {
        //             this.loading = false;
        //             this.options = response.data.data || [];
        //         })
        //         .catch(() => {
        //             this.loading = false;
        //             this.list = [];
        //             this.total = 0;
        //         });
        // },
        getList() {
            this.loading = true;
            var formDatas = { screen_id: this.query.screen_id };
            screenDetail(formDatas)
                .then((response) => {
                    this.loading = false;
                    this.query = response.data || [];
                    this.imagesList = response.data.imagesList || [];
                    if (this.query.is_use == 1) {
                        this.query.is_use = true;   
                    } else {
                        this.query.is_use = false;
                    }
                    this.query.type = this.query.type.toString()
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        cateAdd() {
            var formDatas = { cate_name: this.cate_name };
            if (!this.cate_name) {
                this.$message.error("标签名不能为空");
                return;
            }
            createAdd(formDatas)
                .then((response) => {
                    if (response) {
                        this.cate_name = "";
                        if (this.FinalTags.length > 0) {
                            var bool = true;
                            this.FinalTags.forEach((obj) => {
                                if (response.data.cate_id == obj.cate_id) {
                                    bool = false;
                                }
                            });
                            if (bool) {
                                // this.cate_name =''
                                this.FinalTags.push(response.data);
                            }
                        } else {
                            // this.cate_name = ''
                            this.FinalTags.push(response.data);
                        }
                    }
                    this.loading = false;
                    // this.getCateList();
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        // 保存按钮
        onSubmit(upd_type) {

            if (this.query.name == "") {
                this.$message.error("名称不能为空");
                return false;
            }
            // if (this.query.type == "") {
            //     this.$message.error("类别不能为空");
            //     return false;
            // }
            // if (this.query.url == "") {
            //     this.$message.error("文章id/跳转链接不能为空");
            //     return false;
            // }
            // if (this.query.start_time == "") {
            //     this.$message.error("起始时间不能为空");
            //     return false;
            // }
            // if (this.query.end_time == "") {
            //     this.$message.error("结束时间不能为空");
            //     return false;
            // }
            // if (this.query.is_use == "") {
            //     this.$message.error("是否启用不能为空");
            //     return false;
            // }
            if (this.query.is_use == true) {
                this.query.is_use = 1;
            } else {
                this.query.is_use = 2;
            }

            this.loading = true;
            this.query.imgList = this.imagesList;

            // 打印所有入库的值
            screenCeate(this.query)
                .then((response) => {
                    // console.log(response,'99887766')
                    // return ;
                    if (response.code == 0) {
                        this.$message({
                            message: "操作成功！",
                            type: "success",
                        });

                        // // 在入库之后 对本地的编辑关键字进行session保存
                        // var data = this.dataSource;
                        // // 插入最新输入的关键字
                        // data.unshift({ value: this.query.editor });
                        // this.filterByName(this.dataSource, "value");

                        this.$router.push({ path: `/openScreenNew/openScreenNew` });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        filterByName(data, Name) {
            //data是json对象，Name是根据什么字段去重
            var dest = [];
            for (var i = 0; i < data.length; i++) {
                var ai = data[i];
                if (i == 0) {
                    dest.push(ai);
                } else {
                    var filterData = dest.filter(function (e) {
                        return e[Name] == ai[Name];
                    });
                    if (filterData.length == 0) {
                        dest.push(ai);
                    }
                }
            }
            console.log(dest, "去重之后的数组");
            let jsonStr1 = JSON.stringify(dest);
            sessionStorage.setItem("keywordDataJson", jsonStr1);

            return dest;
        },
        shezhi() {
            this.gaoji = !this.gaoji;
        },
    },
    components: {
        Tinymce,
    },
    computed: {
        editor() {
            return this.$refs.myQuillEditor.quill;
        },
        proStatus() {
            //上传状态
            if (this.pass) {
                return "success";
            } else if (this.pass === false) {
                return "exception";
            } else {
                return "success";
            }
        },
    },
    created() {
        // 将参数拷贝进查询对象
        this.query.screen_id = this.$route.params.screen_id ?  this.$route.params.screen_id : 0 ;
        console.log(this.query.screen_id,'this.query.screen_id_0000000000000000000')
        if (this.query.screen_id != 0) {
            this.getList();
        } else {
            this.query.name = '';
            this.query.type = '';
            this.query.is_use = '';
            this.query.url = '';
            this.videoForm.showVideoPath = '';
            this.videoForm.showVideoPath2 = '';
            this.videoForm.showVideoPath3 = '';
            this.videoForm.showVideoPath4 = '';
            this.videoForm.showVideoPath5 = '';
            this.videoForm.showVideoPath6 = '';
            this.videoForm.showVideoPath7 = '';
        }
    },
    filters: {
        //时间转换 用到moment.js
        formatDate: function (value) {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
    },
};
</script>

<style type="text/scss" lang="scss">
.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.spana {
    width: 40px;
}
div {
    font-size: 14px;
}
p {
    font-size: 14px;
}
>>> .el-row {
    margin-bottom: 12px;
}
.uploadProductDiv {
    width: 1190px;
    box-sizing: border-box;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 4px;
}

.uploadProductDiv-header {
    text-align: center;
    font-size: 30px;
    color: #333333;
    letter-spacing: 0;
    font-weight: bold;
    width: 100%;
    height: 100px;
    line-height: 100px;
    background: #fbd7d9;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
}

.uploadProductDiv-body {
    box-sizing: border-box;
    padding-left: 115px;
    padding-top: 65px;
}

.uploadProductDiv-inputDiv {
    display: flex;
    margin-bottom: 20px;
    position: relative;
}

.uploadProduct-Pname {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    height: 40px;
    width: 140px;
}
.form-input {
    width: 440px;
}
.uploadProduct-input {
    box-sizing: border-box;
    width: 440px;
    height: 40px;
    line-height: 40px;
    background: #f3f0f0;
    border: 1px solid #dedede;
    border-radius: 4px;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    padding-left: 20px;
    outline: none;
    margin-left: 46px;
    position: absolute;
    left: 62px;
}
.uploadProduct-pyuan {
    position: absolute;
    left: 565px;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    height: 40px;
}
.avatar-uploader.upload-add {
    width: 200px !important;
    height: 199px !important;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 199px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 199px;
    line-height: 199px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.button-row {
    margin-top: 20px;
    margin-left: 12%;
}
.inputs {
    border: #757779 1px solid;
    height: 40px;
    margin-left: 20px;
    width: 122px;
}
.infoDetailBoxTwo {
    height: 190px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid #dddddd;
    position: relative;
    div {
        width: 72%;
    }
}
.infoDetailBoxs {
    height: 80px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid #dddddd;
    position: relative;
    div {
        width: 56%;
    }
}
.infoDetailBoxContent {
    height: 480px;
    display: flex;
    box-sizing: border-box;
    padding: 35px 50px;
    border-bottom: 1px solid #dddddd;
    position: relative;
    div {
        width: 56%;
    }
}
.gcDetails {
    box-sizing: border-box;
    padding: 15px 50px;
    border-bottom: 1px solid #dddddd;
    > div {
        display: flex;
    }
}
.gcDetails > div > :nth-child(2) {
    margin-left: 50px;
}
.chakandetail {
    color: #2490fa;
    cursor: pointer;
    margin-left: 10px;
}
.jlSpan {
    margin-left: 35px;
}
.imgsDiv {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    width: 525px;
    img {
        margin-right: 10px;
        margin-bottom: 10px;
    }
}
.shezhi {
    width: 100%;
    background: lightgray;
    height: 50px;
    text-align: left;
    padding-left: 2%;
    font-size: large;
    line-height: 50px;
}
input {
    width: 30%;
}
</style>
<style lang="scss">
.find-add {
    margin-top: 10px;
}
.find-add .el-form-item__label {
    margin-top: 0;
}
</style>
